import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "19d6a14a-1305-4f26-9638-d481d78c0fcb",
    content: "Pure signal at one frequency",
    options: {},
  },
  {
    id: "1f927a73-5f1f-4ab7-b554-106702733fcf",
    content: "Dirac δ",
    options: {},
  },
  {
    id: "9732793a-dbfc-438b-b36a-462b1702f598",
    content: "Rectangular window",
    options: {},
  },
  {
    id: "877f34fe-8eee-4f68-9bfd-d0ff9080e477",
    content: "None of them",
    options: {},
  },
];

export const task: Task = {
  id: "918fb20a-e6d1-4e22-822e-6d174101a58b",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 4,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["877f34fe-8eee-4f68-9bfd-d0ff9080e477"],
};
